
export function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-shield-flash-line',
      title: 'Tráfico Pro Élite (Anti-Bloqueos)',
      description: 'La estructura exacta de campañas que uso para evitar bloqueos y conseguir clientes a bajo costo',
    },
    {
      icon: 'ri-message-3-line',
      title: 'Cierre de Ventas Semiautomático',
      description: 'Guiones de ChatGPT y BotConversa probados para que los clientes te pidan comprar a ti',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Tu Máquina de Ventas 24/7',
      description: 'Plantillas listas para usar en Lovable/Readdy. Clona mi negocio en minutos',
    },
    {
      icon: 'ri-user-star-line',
      title: 'Mentores con experiencia',
      description: 'Aprende de expertos en ventas digitales de nuestra comunidad',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Recupera tu inversión rápido',
      description: 'Resultados en tiempo récord con nuestra metodología',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantía de satisfacción',
      description: 'garantia de por vida',
    },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16 space-y-3 sm:space-y-4">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900">Beneficios clave</h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed">
            Transforma tu conocimiento en una fuente de ingresos constante
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group p-5 sm:p-6 lg:p-8 rounded-xl sm:rounded-2xl bg-gradient-to-br from-white to-gray-50 border-2 border-gray-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 rounded-xl sm:rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className={`${benefit.icon} text-white text-xl sm:text-2xl lg:text-3xl`}></i>
              </div>
              <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{benefit.title}</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{benefit.description}</p>
              <div className="mt-3 sm:mt-4 flex items-center gap-2 text-emerald-600 font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-xs sm:text-sm whitespace-nowrap">Más información</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 text-center p-6 sm:p-8 lg:p-12 rounded-2xl sm:rounded-3xl bg-gradient-to-r from-emerald-50 to-cyan-50 border-2 border-emerald-200">
          <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">¿Listo para comenzar tu transformación digital?</h3>
          <p className="text-sm sm:text-base lg:text-lg text-gray-600 mb-6 sm:mb-8 max-w-2xl mx-auto">
            Únete a cientos de estudiantes que ya están generando ingresos con nuestras estrategias probadas
          </p>
          <button
            onClick={() => {
              const checkoutSection = document.getElementById('checkout');
              if (checkoutSection) {
                checkoutSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            className="w-full sm:w-auto px-6 sm:px-8 lg:px-10 py-3 sm:py-4 rounded-lg sm:rounded-xl font-bold text-sm sm:text-base lg:text-lg bg-gradient-to-r from-emerald-500 to-cyan-500 text-white hover:shadow-2xl hover:shadow-emerald-500/50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-block"
          >
            Acceder Ahora con Descuento →
          </button>
        </div>
      </div>
    </section>
  );
}
